// pickers.ts — fill the Class + Subclass <select> shells from the inlined picker JSON.
//
// table_item_class_inc.php keeps the bare <select> shells (with their inline onchange handlers,
// redirectInputItemId / querySubclassTable) but no longer server-renders the <option> loop. The options
// come from window.FT_CLASS_PICKER / FT_SUBCLASS_PICKER — both built server-side with item_private=0, so
// private/incomplete classes (e.g. "The Machinist") never enter the list, yet item.php still renders one
// when visited directly. We inject native <option>s (TomSelect reads them, incl. data-icon) and run
// initializeTomSelect so the controls skin exactly as before.

function fillSelect(selectId: string, options: FtPickerOption[] | undefined): void {
    const sel = document.getElementById(selectId) as HTMLSelectElement | null;
    if (!sel || !Array.isArray(options)) return;

    const selectedId = sel.getAttribute('data-ft-selected') || '';

    // If TomSelect already skinned this control, revert to the native select before repopulating.
    const ts = (sel as HTMLSelectElement & { tomselect?: { destroy?: () => void } }).tomselect;
    if (ts && typeof ts.destroy === 'function') ts.destroy();

    // Drop everything except the placeholder (value === '') so re-mounts don't duplicate.
    Array.from(sel.options).forEach(o => { if (o.value !== '') sel.removeChild(o); });

    for (const opt of options) {
        if (!opt || !opt.item_id) continue;
        const o = document.createElement('option');
        o.value = opt.item_id;
        o.textContent = opt.item_name || '';
        // Icon via the KEY path (data-icon-key): initializeTomSelect → ftResolveSelectIconKeys resolves it
        // to a real <img src=iconUrl(item_id)> BEFORE TomSelect reads the options. Setting data-icon to the
        // server icon_ph() output instead ships an inert <i class="ft-icon"> placeholder TomSelect never
        // mounts — which renders blank (the bug). The class item_id IS the icon registry key.
        o.setAttribute('data-icon-key', opt.item_id);
        if (opt.item_id === selectedId) o.selected = true;
        sel.appendChild(o);
    }
}

/** Populate both pickers and (re)initialize TomSelect. Safe to call once per page. */
export function mountPickers(): void {
    fillSelect('input_class_form_select', window.FT_CLASS_PICKER);
    fillSelect('input_subclass_form_select', window.FT_SUBCLASS_PICKER);
    if (typeof initializeTomSelect === 'function') initializeTomSelect();
}
